import axios from "axios";
import i18next from "i18next";
import { API_URL } from "./runtimeEnv.js";
import { getUser, logOutUser, getLocalKey, setReturnURL } from '../utils/commonfunction';
import Swal from "sweetalert2";
import { SWAL_SETTINGS } from "./Constants";

const Axios = (options = {extraHeaders: {}}) => {
  const baseURL = API_URL
  let headers = {
    language : i18next.resolvedLanguage || i18next.language || getLocalKey('system_language') || 'en'
  };

  try{
    const userData = getUser(options?.role);
 
    if(userData && userData.token){
      headers.Authorization = `Bearer ${userData.token}`;
    }
    if(options && options['active-user-email']){
      headers['X-active-user-email'] = options['active-user-email']
    }else{
      if(localStorage.getItem("cashierDetail")){
        const cashierDetail = JSON.parse(localStorage.getItem("cashierDetail")); 
        let option = {
          "active-user-email" : cashierDetail.email
        };
        headers['X-active-user-email'] = option['active-user-email'];
      }
    }
    if(options && options['active-user-password']){
      headers['X-active-user-password'] = options['active-user-password']
    }
    
  }catch(err){
    console.log(err);
  }

  const axiosInstance = axios.create({
    baseURL: baseURL,
    headers : {...headers,...options.extraHeaders}
  });

  axiosInstance.interceptors.response.use((response) =>
    
    new Promise((resolve, reject) => {
      // const new_token = response.headers['new_token'];

      // if (new_token) {
      //   if (options?.role === "restaurant") {
      //     let restaurant_data = localStorage.getItem('restaurant');
      //     if (restaurant_data) {
      //       const parsed = JSON.parse(restaurant_data);
      //       parsed.token = new_token;
      //       localStorage.setItem('restaurant', JSON.stringify(parsed));
      //     }
      //   }
      
      //   if (options?.role === "cashier") {
      //     let cashier_data = localStorage.getItem('cashier');
      //     if (cashier_data) {
      //       const parsed = JSON.parse(cashier_data);
      //       parsed.token = new_token;
      //       localStorage.setItem('cashier', JSON.stringify(parsed));
      //     }
      //   }
      //   //super_admin
      //   if (options?.role === "super_admin") {
      //     let super_admin_data = localStorage.getItem('super_admin');
      //     if (super_admin_data) {
      //       const parsed = JSON.parse(super_admin_data);
      //       parsed.token = new_token;
      //       localStorage.setItem('super_admin', JSON.stringify(parsed));
      //     }
      //   }
      // }
      
   
      resolve(response.data);
 
    }), (error) => {
      console.error("error -----> ", error);
      // WRDS-769: backend in maintenance answers 503 {maintenance:true} —
      // surface the root overlay (GlobalLayout listens) for clients that
      // missed the socket broadcast.
      if (error?.response?.status === 503 && error.response.data?.maintenance === true) {
        window.dispatchEvent(new CustomEvent('wilreji:maintenance', {
          detail: { message: error.response.data.message || '' },
        }));
      }
      if (error && error.response && error.response.status && error.response.status === 401) {
        if (!options?.suppressUnauthorizedHandling) {
          setReturnURL(options?.role);
          logOutUser(options?.role);
          Swal.fire({
            icon: "error",
            text: (error?.response?.data?.message) || "Session expired, please login again.",
            ...SWAL_SETTINGS,
          });
        }
      }
      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

export default Axios;
